import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ScholarshipTypeActions from './scholarshiptype.actions';
import { ScholarshipTypeService } from '../../services/scholarshiptype.service';

@Injectable()
export class ScholarshipTypeEffects {
  loadScholarshipType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipTypeActions.loadScholarshipType),
      exhaustMap((_) =>
        this.scholarshipTypeService.getScholarshipType().pipe(
          map((data) =>
            ScholarshipTypeActions.loadScholarshipTypeSuccess({
              scholarshipType: data,
            })
          ),
          catchError((error) =>
            of(ScholarshipTypeActions.loadScholarshipTypeFailure({ error }))
          )
        )
      )
    )
  );

  addScholarshipType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipTypeActions.addScholarshipType),
      concatMap(({ newScholarshipType }) =>
        this.scholarshipTypeService
          .createScholarshipType(newScholarshipType)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ScholarshipTypeActions.addScholarshipTypeSuccess({
                newScholarshipType: data,
              });
            }),
            catchError((error) =>
              of(
                ScholarshipTypeActions.addScholarshipTypeFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateScholarshipType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipTypeActions.updateScholarshipType),
      map((action) => action.updateScholarshipType),
      concatMap((updateScholarshipType) =>
        this.scholarshipTypeService
          .updateScholarshipType(updateScholarshipType)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return ScholarshipTypeActions.updateScholarshipTypeSuccess({
                updateScholarshipType: updateScholarshipType,
              });
            }),
            catchError((error) =>
              of(
                ScholarshipTypeActions.updateScholarshipTypeFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeScholarshipType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipTypeActions.removeScholarshipType),
      map((action) => action.ids),
      concatMap((ids) =>
        this.scholarshipTypeService.deleteScholarshipType(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ScholarshipTypeActions.removeScholarshipTypeSuccess({ ids });
          }),
          catchError((error) =>
            of(
              ScholarshipTypeActions.updateScholarshipTypeFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private scholarshipTypeService: ScholarshipTypeService,
    private notification: NotificationService
  ) {}
}
